export const actionTypes = {
    CHAGE: 'CHANGE_LOADING'
}

export const changeLoadingRoterization = (payLoad) =>({
    type: actionTypes.CHAGE,
    payLoad
})